<div class="px-4">
  <dx-toolbar class="graphs-toolbar">
    <dxi-item
      widget="dxSelectBox"
      [options]="selectBoxOptions"
      location="before">
    </dxi-item>
    <dxi-item
      widget="dxButton"
      location="after"
      [options]="{
              icon: 'export',
              type: 'normal',
              hint: 'Exporter',
              onClick: exportChart
          }">
    </dxi-item>
    <dxi-item
      widget="dxButton"
      location="after"
      [options]="{
              icon: 'refresh',
              type: 'normal',
              hint: 'Réinitialiser',
              onClick: resetChart
          }">
    </dxi-item>
  </dx-toolbar>

</div>
<div class="py-2 px-4">
  <!--            (onPointClick)="chartPointClick($event)"
              (onZoomEnd)="chartZoomEnd($event)"-->
  <dx-chart
    id="history-chart"
    (onPointClick)="chartPointClick($event)"
    [dataSource]="ds">
    <!--<dxo-title [text]=""></dxo-title>-->

    <dxo-zoom-and-pan
      [dragToZoom]="true"
      valueAxis="none"
      argumentAxis="both"
    ></dxo-zoom-and-pan>

    <dxi-series argumentField="tracker_time" [valueField]="field"></dxi-series>

    <dxo-argument-axis argumentType="datetime"></dxo-argument-axis>
    <dxo-value-axis>
      <dxo-label [customizeText]="valueAxisAddUnit"></dxo-label>
    </dxo-value-axis>

    -
    <dxo-size height="120" width="100%"></dxo-size>

    <dxo-common-series-settings width="2">
      <dxo-point [visible]="false"></dxo-point>
      <dxo-hover-style width="2"></dxo-hover-style>
    </dxo-common-series-settings>

    <dxo-legend [visible]="false"></dxo-legend>

    <dxo-common-axis-settings>
      <dxo-grid [visible]="true"></dxo-grid>
    </dxo-common-axis-settings>



    <!--<dxo-scroll-bar [visible]="scrollVisible"></dxo-scroll-bar>-->

   <dxo-export [enabled]="false"></dxo-export>

    <dxo-tooltip contentTemplate="historyChartTooltip" [zIndex]="300000" argumentFormat="shortDateShortTime"
                 [enabled]="true"></dxo-tooltip>
    <div *dxTemplate="let info of 'historyChartTooltip'">
      <div>{{info.valueText}} {{unit}} - {{info.argumentText}}</div>
    </div>
  </dx-chart>
</div>



<dx-load-panel
  shadingColor="rgba(0,0,0,0.05)"
  [position]="{of: host.nativeElement}"
  [visible]="isLoading"
  [showIndicator]="false"
  [showPane]="false"
  [shading]="true"
  [closeOnOutsideClick]="false">
</dx-load-panel>
